import styled from 'styled-components';
import { PageHeader, PageHeaderAction, PageHeaderRow, PageTitle } from 'containers/groupsView/groupsView.styled';
import { spacer, media } from 'settings/style';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  height: calc(100vh - 200px);
  position: relative;
  overflow: hidden;

  section {
    margin: ${spacer.xl} 0;
    form {
      max-width: 400px;
    }
  }
`;

export const StyledTreeContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;

  #tree {
    width: 100%;
    height: 100%;

    ${media.md`
      height: calc(100vh - 320px) !important;
    `}

    .light {
      font-size: 14px !important;
    }
    svg {
      transform-origin: top left;
    }
  }
`;

export const StyledButtonText = styled.span`
  display: inline-flex;
`;

/** Top row: share controls aligned to the end above the tree */
export const ShareToolbarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

export const ShareToolbarActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  ${media.md`
    flex-wrap: wrap;
    justify-content: flex-end;
  `}
`;

export const FamilyTreePageHeader = styled(PageHeader)`
  ${media.md`
    padding: 1rem 0 0.75rem;
  `}
`;

export const FamilyTreeHeaderRow = styled(PageHeaderRow)`
  ${media.md`
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  `}
`;

export const FamilyTreePageTitle = styled(PageTitle)`
  ${media.md`
    width: 100%;
    font-size: clamp(1rem, 4.2vw, 1.35rem);
    line-height: 1.2;
    white-space: nowrap;
  `}
`;

export const FamilyTreeHeaderActions = styled(PageHeaderAction)`
  ${media.md`
    width: 100%;
    display: flex;
    justify-content: flex-end;
  `}
`;

export const DecisionModalParagraph = styled.p`
  margin-bottom: 0;
`;

/** Shared Drawer body padding (avoids inline style objects in JSX) */
export const drawerBodyStyle = { paddingBottom: 80 } as const;

export const RequestsPanel = styled.div`
  padding: 8px 0 24px;
`;

export const RequestsPageTitle = styled.h2`
  margin: 0 0 20px;
  font-size: 1.25rem;
  font-weight: 600;
`;

export const RequestsToolbarRow = styled(ShareToolbarRow)`
  margin-bottom: 0;
`;

export const RequestsToolbarActions = styled(ShareToolbarActions)``;

export const RequestsEmptyState = styled.p`
  margin: 0;
  color: #6b7280;
  font-size: 0.95rem;
`;

export const RequestsList = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RequestsListItem = styled.div`
  font-size: 0.95rem;
  color: #374151;
`;
